import { render, staticRenderFns } from "./LavoraConNoi.vue?vue&type=template&id=e9d36ad4&"
import script from "./LavoraConNoi.vue?vue&type=script&lang=js&"
export * from "./LavoraConNoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports